export default "__VITE_ASSET__BYLLIK1A__"